import { Paths } from 'src/Routes';
import { Divider, Grid, GridChild } from '@norges-domstoler/dds-components';
import { NavLink } from 'react-router';
import { useTranslation } from 'react-i18next';

export const Header = () => {
  const { t } = useTranslation();
  return (
    <>
      <Grid as="header">
        <GridChild columnsOccupied="all">
          <section className="flex min-h-[52px] w-full items-center gap-4 text-inherit">
            <NavLink className="text-inherit no-underline" to={Paths.base}>
              <div className="mt-[-4px] whitespace-nowrap text-xl font-normal">
                {t('header.page.title')}
              </div>
            </NavLink>
          </section>
        </GridChild>
      </Grid>
      <Divider color="subtle" />
    </>
  );
};
